import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'does_facility_consult_workers_provide_minimum_notice_period'

export const dataPointDefinition = {
  retracedId: 'does_facility_consult_workers_provide_minimum_notice_period',
  name: 'Does the facility consult with workers and/or provide a minimum notice period for overtime work and/or changes in rest d',
  description: 'You have indicated that there are "No applicable legal requirements". ',
  meta: {
    slcpMeta: {
      key: 'wh-ove-3',
      number: 'WH-OVE-4',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'wh-ove-3', version: '1.7.0', provider: 'slcp'}],
  sortingId: 36410,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
